// ============================================================================
// POLISH TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Jedność, która przynosi pokój",
    author: "Autor: Emmanuel",
    subtitle: "Każda religia ma swoje racje, nasze granice pochodzą z przeszłości",
    description: "Moduł refleksji nad duchową jednością i pokojem między tradycjami",
    
    nav: {
      intro: "Wstęp",
      religions: "Religie",
      common: "Wspólne podstawy",
      humility: "Pokora"
    },

    intro: {
      emmanuelSays: "Emmanuel mówi:",
      ourBordersFromPast: "Nasze granice pochodzą z przeszłości",
      bordersDescription: "Każda religia ma swoje racje. Nasze podziały nie są wolą Bożą, ale owocem historii, geografii, kultury.",
      divisionWork: "Podział, izolacja przez bariery i granice strachu, jest dziełem naszej niebezpiecznej przeszłości.",
      sharedHumanity: "Urodziliśmy się w różnych tradycjach, ale dzielimy tę samą ludzkość.",
      
      revelationTitle: "Objawienie, które otwiera oczy",
      surprisedLearning: "Byłem zaskoczony pewnego dnia dowiadując się, że Żydzi są również synami Bożymi.",
      angelMichael: "Że anioł Michał jest wielkim posłańcem dla muzułmanów.",
      jesusNames: "Że Jezus, Isa, Jeszua są znani na różne sposoby, nawet w wierze chrześcijańskiej.",
      diverseTribes: "Ponieważ istnieją różne plemiona, różne kościoły, różne rodziny.",
      sameRealities: "Mówimy o tych samych rzeczywistościach różnymi nazwami. To powinno nas zbliżać, nie dzielić.",
      
      respectTitle: "Szacunek: fundament pokory, strażnik pokoju",
      respectFoundation: "Nawet jeśli braterstwo nie jest obiektywnie możliwe, szacunek jest fundamentem pokory, strażnikiem pokoju.",
      understandingProcess: "Zrozumienie i szanowanie innych religii to proces pokory. Nie oznacza to wyrzeczenia się swojej wiary, ale akceptacji, że inni również szukają prawdy.",
      
      whatBindsUs: "Co naprawdę nas łączy",
      seekingRelation: "Każda religia szuka relacji. Każdy człowiek szuka pokoju.",
      loveOfGod: "Tą relacją, która łączy nas wszystkich, jest miłość Boża.",
      universalLink: "Miłość jest uniwersalnym łącznikiem przekraczającym wszystkie granice, wszystkie języki, wszystkie tradycje.",
      
      inclusionTitle: "Włączenie: jeszcze szersze niż różnorodność religijna",
      vastInclusion: "Różnorodność religijna jest ogromna, ale jeszcze większe jest włączenie innych tam, gdzie są powołani przez Boga.",
      respectDifferences: "Szacunek dla różnic koloru, płci, włączenie czyni nas wyjątkowymi ludźmi, kochanymi przez Boga.",
      jesusCommand: "Jezus powiedział: 'Miłujcie się wzajemnie.'",
      
      communitySpirit: "Zerwanie z duchem wspólnotowym",
      communityTerror: "Wspólnotowość to terror zamaskowanej nienawiści zła. Przekształca wiarę w plemienną tożsamość, w mur który dzieli, w broń która rani.",
      pridePolitics: "Nasze duchy partyjne pchają nas ku polityce pychy:",
      prideQuotes: "Mam rację cię krzywdzić. Mam rację i już. Mam rację prowadzić dobrą wojnę.",
      watchHeart: "Bądźcie czujni na sedno problemu, na korzeń naszego własnego zła.",
      refuseDivision: "Odmówmy tego dryfowania, które dzieli ludzkość w imię Boga.",
      
      freedomTitle: "Aby być wolnym, uczynić innych wolnymi",
      freedomOthers: "Aby być wolnym, trzeba umieć uczynić innych wolnymi również.",
      defendFreedom: "Moja wolność wiary ma wartość tylko wtedy, gdy bronię wolności wszystkich. Uciskanie innych to skazywanie siebie na niewolę.",
      
      changeHeartTitle: "Zmień swoje serce: bądź prawdziwą latarnią",
      recognizeDecency: "Uznaj, że przyzwoitość nie jest taka sama dla każdego.",
      changeYourself: "Zmiana ciebie najpierw, stopniowo. Zmień swoje serce, przemień swoje życie, bądź prawdziwą latarnią.",
      beExample: "Nie sikaj na trawnik, bo zginie... Nie narzucaj swoich zasad innym, ale stań się żywym przykładem przez swoją przemianę.",
      
      childrenPeaceTitle: "Nasze dzieci będą żyć w pokoju w różnorodności",
      avoidPursuit: "Unikaj pogoń za słowami dla słów.",
      peaceChoice: "Jeśli dziś wybierzemy szacunek, nasze dzieci przyszłości będą żyć w pokoju w różnorodności. Pokój zaczyna się od nas, teraz, w naszych słowach i czynach.",
      
      discernTitle: "Rozróżnić: człowiek czy Bóg?",
      manSpeaks: "Zbyt często to serce człowieka mówi i dzieli.",
      seeFruits: "Widzimy to po owocach słów i wypowiedzi: kradzież, zniszczenie, wojny. Bądźcie czujni na manipulację słowami dla własnej pychy.",
      
      lookPeaceTitle: "Patrzeć ku pokojowi i miłości",
      lookPeaceAll: "Patrzeć ku pokojowi dla wszystkich, patrzeć ku miłości Boga dla innych.",
      godSpeaks: "Gdy słowa przynoszą pokój, pojednanie, jedność: to Bóg mówi. Gdy przynoszą podział, nienawiść, wojnę: to pycha człowieka.",
      
      watchWordsTitle: "Czuwać nad naszymi słowami",
      watchShares: "Czuwać nad naszymi podziałami, czuwać nad naszymi szkodliwymi przeciwnymi słowami wobec innych.",
      disqualify: "Te zła nas dyskwalifikują. Owoce naszych słów ujawniają, kto mówi w nas: Bóg czy nasza własna pycha?",
      
      wisdomMaturityTitle: "Mądrość i dojrzałość wobec naszej natury",
      useScriptures: "Używanie pism (praw) do krzywdzenia to nasz nawyk, proces niemal naturalny i psotny.",
      hateSin: "W obliczu naszej grzesznej natury brzydzimy się złem i ludźmi czyniącymi zło.",
      separateActs: "Ale przez mądrość i dojrzałość musimy oddzielić czyny od naszej ludzkiej nędzy.",
      compassionNature: "Uznać naszą zwierzęcą naturę potrzebującą współczucia i łaski, jednocześnie chroniąc się według kontekstu.",
      
      denounceLeadersTitle: "Demaskować skorumpowanych przywódców duchowych",
      watchLeaders: "Bądźcie czujni na przywódców duchowych lub władców, którzy starają się utrzymać w tajemnicy swoje odchylenia i nieuczciwość.",
      noJustice: "Bez sprawiedliwości, brak przykładu. Bez wiedzy, inne ofiary giną przez nasze milczenie.",
      silenceComplicity: "Milczenie wobec niesprawiedliwości to współudział. Prawda musi być powiedziana, aby chronić innych."
    },

    religions: {
      title: "Różne religie, jedna ludzkość",
      intro: "Chrześcijanie, Muzułmanie, Żydzi, Hindusi, Buddyści... i wielu innych: wszyscy szukają prawdy",
      theirGod: "Ich Bóg:",
      theGood: "Dobro:",
      theEvil: "Zło:",
      theAngels: "Aniołowie:",
      theUnity: "Jedność:",
      values: "Wartości:",
    commonGoal: "Wspólny Cel",
    seekingPeace: "Wszystkie religie dzielą wspólny cel: poszukiwanie pokoju, promowanie miłości i budowanie lepszego świata. Poza naszymi różnicami wszyscy jesteśmy zjednoczeni w tym poszukiwaniu mądrości i harmonii.",
      
      christianity: {
        name: "Chrześcijaństwo",
        godText: "Jeden jedyny Bóg, Ojciec Stwórca",
        goodText: "Miłość bliźniego, przebaczenie, pokój",
        evilText: "Nienawiść, egoizm, przemoc",
        angelsText: "Posłańcy Boży (Gabriel, Michał...)",
        unityText: "Jeden Bóg dla wszystkich ludzi",
        values: "Miłość,Przebaczenie,Pokój,Pokora,Sprawiedliwość"
      },
      islam: {
        name: "Islam",
        godText: "Allah, Jedyny i Miłosierny",
        goodText: "Sprawiedliwość, miłosierdzie, pokój",
        evilText: "Ucisk, kłamstwo, podział",
        angelsText: "Aniołowie światła (Dżibril, Mikail...)",
        unityText: "Nie ma boga poza Allahem",
        values: "Pokój,Sprawiedliwość,Miłosierdzie,Szacunek,Litość"
      },
      judaism: {
        name: "Judaizm",
        godText: "JHWH, Wieczny Jedyny",
        goodText: "Sprawiedliwość, współczucie, życie",
        evilText: "Ucisk, oszczerstwo, nienawiść",
        angelsText: "Niebiańscy posłańcy (Malakhim)",
        unityText: "Słuchaj Izraelu, Wieczny jest Jeden",
        values: "Sprawiedliwość,Życie,Pamięć,Pokój,Nauka"
      },
      hinduism: {
        name: "Hinduizm",
        godText: "Brahman, najwyższa rzeczywistość",
        goodText: "Niestosowanie przemocy (ahimsa), prawy obowiązek",
        evilText: "Przemoc, ignorancja duchowa",
        angelsText: "Dewowie, życzliwe istoty niebiańskie",
        unityText: "Wszystko jest Jednym w Brahmanie",
        values: "Niestosowanie_przemocy,Prawda,Współczucie,Czystość,Harmonia"
      },
      buddhism: {
        name: "Buddyzm",
        godText: "Nie ma boga stwórcy, ale szacunek dla sacrum",
        goodText: "Współczucie, mądrość, pokój",
        evilText: "Cierpienie spowodowane ignorancją",
        angelsText: "Bodhisattwowie, istoty oświecone",
        unityText: "Natura Buddy w każdym",
        values: "Współczucie,Mądrość,Pokój,Niestosowanie_przemocy,Przebudzenie"
      }
    },

    common: {
      title: "Wspólne podstawy",
      intro: "Dobro, Zło, Aniołowie, Jeden Bóg, Relacja, Włączenie: co jednoczy ludzkość",
      
      goodTitle: "Dobro",
      goodDescription: "Wszystkie religie nauczają miłości, sprawiedliwości i współczucia",
      goodExamples: "Miłuj bliźniego jak siebie samego|Czyń dobro bez rozróżnienia|Chroń słabych i uciśnionych|Mów prawdę z życzliwością|Dziel się tym, co masz",
      
      evilTitle: "Zło",
      evilDescription: "Wszystkie potępiają przemoc, kłamstwo i ucisk",
      evilExamples: "Zabijać bez sprawiedliwości|Kraść i wyzyskiwać|Kłamać i oszczerczać|Gardzić i poniżać|Dzielić i nienawidzić",
      
      angelsTitle: "Aniołowie i Istoty Duchowe",
      angelsDescription: "Prawie wszystkie uznają życzliwych posłańców niebiańskich",
      angelsExamples: "Aniołowie posłańcy Boga|Przewodnicy duchowi|Istoty światła|Niebiańscy obrońcy|Bodhisattwowie i Dewowie",
      
      godTitle: "Jeden Bóg (lub Najwyższa Rzeczywistość)",
      godDescription: "Większość wierzy w jedno źródło, stwórcę lub ostateczną rzeczywistość",
      godExamples: "Chrześcijaństwo, Islam, Judaizm: Jeden Bóg|Hinduizm: Brahman, Najwyższy Jeden|Buddyzm: Uniwersalna natura Buddy|Wszyscy szukają ostatecznej prawdy|Wszyscy dążą do jedności i pokoju",
      
      relationTitle: "Relacja i Pokój",
      relationDescription: "To, co naprawdę łączy wszystkie religie i wszystkich ludzi",
      relationExamples: "Każda religia szuka relacji z boskością|Każdy człowiek szuka pokoju|Tą relacją, która łączy nas wszystkich, jest miłość Boża|Miłość jest uniwersalnym łącznikiem|Pokój jest naszym wspólnym dążeniem",
      
      inclusionTitle: "Włączenie: Kochani przez Boga",
      inclusionDescription: "Różnorodność religijna jest ogromna, ale włączenie jest jeszcze większe",
      inclusionExamples: "Włączenie innych tam, gdzie są powołani przez Boga|Szacunek dla różnic koloru|Szacunek dla różnic płci|Włączenie czyni nas wyjątkowymi ludźmi, kochanymi przez Boga|Jezus powiedział: 'Miłujcie się wzajemnie'",
      
      finalQuote: "Byłem zaskoczony pewnego dnia dowiadując się, że Żydzi są również synami Bożymi, że anioł Michał jest wielkim posłańcem dla muzułmanów, że Jezus, Isa, Jeszua są znani na różne sposoby nawet w wierze chrześcijańskiej. Ponieważ istnieją różne plemiona, różne kościoły, różne rodziny.",
      finalQuote2: "Mówimy o tych samych rzeczywistościach różnymi nazwami.",
      quoteAuthor: "Emmanuel, Jedność, która przynosi pokój"
    },

    humility: {
      title: "7 kroków ku pokorze i pokojowi",
      intro: "Proces przekraczania wspólnotowości i stawania się prawdziwą latarnią",
      
      step: "Krok",
      action: "Działanie:",
      
      step1Title: "Uznać: nasze granice pochodzą z przeszłości",
      step1Description: "Podział, izolacja przez bariery i granice strachu, jest dziełem naszej niebezpiecznej przeszłości. Nasze podziały nie są wolą Bożą.",
      step1Action: "Zaakceptować, że moja tradycja jest tylko moja, i jestem częścią różnorodności chcianej przez Boga",
      
      step2Title: "Szacunek: fundament pokory, strażnik pokoju",
      step2Description: "Nawet jeśli braterstwo nie jest obiektywnie możliwe, szacunek jest fundamentem.",
      step2Action: "Szanować wszystkie wierzenia, nawet nie rozumiejąc wszystkiego",
      
      step3Title: "Zrozumieć bez osądzania",
      step3Description: "Dziś zrozumienie innych jest niezbędnym procesem pokory.",
      step3Action: "Naprawdę słuchać, w co wierzą inni, bez osądzania",
      
      step4Title: "Zmienić siebie najpierw: być prawdziwą latarnią",
      step4Description: "Uznać, że przyzwoitość nie jest taka sama dla każdego. Zmień swoje serce stopniowo, przemień swoje życie, stań się prawdziwym światłem.",
      step4Action: "Nie narzucać moich zasad innym, ale być żywym przykładem przez moją przemianę",
      
      step5Title: "Zerwać z duchem wspólnotowym",
      step5Description: "Nasze duchy partyjne pchają nas ku polityce pychy: 'Mam rację cię krzywdzić, mam rację i już.' Bądźcie czujni na sedno problemu, na korzeń naszego własnego zła.",
      step5Action: "Odrzucić wypowiedzi dzielące we własnej społeczności",
      
      step6Title: "Aby być wolnym, uczynić innych wolnymi",
      step6Description: "Moja wolność zależy od tej, którą daję innym.",
      step6Action: "Bronić wolności sumienia wszystkich, nie tylko mojej",
      
      step7Title: "Unikać pogoń za słowami dla słów",
      step7Description: "Nie odpowiadać na nienawiść nienawiścią, na obelgi obelgami.",
      step7Action: "Wybrać pokój, aby nasze dzieci żyły w pokoju w różnorodności",
      
      discernFruits: "Rozróżniać po owocach",
      humanHeart: "Serce człowieka, które dzieli",
      lookGodLove: "Patrzeć ku miłości Boga",
      watchOurWords: "Czuwać nad naszymi słowami",
      
      prideFruits: "Owoce ludzkiej pychy",
      prideFruitsList: "Duch partyjny: \"Mam rację, kropka\"|Polityka pychy: \"Mam rację, by cię skrzywdzić\"|Używanie pism do krzywdzenia (podstępny proces)|Nienawiść do osób (nie tylko do czynów)|Przywódcy duchowi ukrywający swoje odchylenia i nieuczciwość|Współwinne milczenie wobec niesprawiedliwości|Podział i wojny|Nienawiść przebrana za pobożność|Kradzież i zniszczenie|Manipulacja dla pychy|Pogarda i przemoc",
      
      godFruits: "Owoce miłości Boga",
      godFruitsList: "Oddzielanie czynów od osoby z mądrością|Współczucie dla naszej ludzkiej nędzy|Łaska, chroniąc się zgodnie z kontekstem|Potępianie niesprawiedliwości, aby chronić innych|Mówienie prawdy z odwagą|Pokój dla wszystkich|Miłość bez rozróżnienia|Pojednanie i jedność|Pokora i szacunek|Wolność dla wszystkich",
      
      finalQuote: "Nawet jeśli braterstwo nie jest obiektywnie możliwe, szacunek jest fundamentem pokory, strażnikiem pokoju. Unikaj pogoń za słowami dla słów, a nasze dzieci przyszłości będą żyć w pokoju w różnorodności.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Szacunek jest fundamentem pokory, strażnikiem pokoju. Nasze dzieci będą żyć w pokoju w różnorodności, jeśli dziś wybierzemy szacunek.",
      author: "Emmanuel, Jedność, która przynosi pokój"
    }
};

export default unityTranslations;
